// utils/employeeLogger.js
import API_URLS from "../summaryapi/apiUrls";

export const logEmployeeAction = async (actionType, screenName = null, actionDetails = null) => {
  const adminId = sessionStorage.getItem("adminId") ? atob(sessionStorage.getItem("adminId")) : null;
  const adminUsername = sessionStorage.getItem("adminUsername") ? atob(sessionStorage.getItem("adminUsername")) : null;
  
  if (!adminId) return;

  let description = '';
  switch (actionType) {
    case 'LOGIN':
      description = `logged in`;
      break;
    case 'LOGOUT':
      description = `logged out`;
      break;
    case 'SCREEN_VIEW':
      description = `${screenName} (Viewed)`;
      break;
    case 'ITEM_CREATED':
      description = `created ${screenName} in (${actionDetails})`;
      break;
    case 'ITEM_UPDATED':
      description = `${screenName} in (${actionDetails})`;
      break;
    case 'ITEM_DOWNLOADED':
      description = `${screenName} in (${actionDetails})`;
      break;
    case 'ITEM_DELETE':
      description = `${screenName} in (${actionDetails})`;
      break;
    default:
      description = `performed action: (${actionType})`;
  }

  try {
    await fetch(API_URLS.createemployeelog.url, {
      method: API_URLS.createemployeelog.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        admin_id: adminId,
        employee_details: description
      }),
    });
  } catch (error) {
    console.error("Error logging employee action:", error);
  }
};